import { render } from "./chatRoomItem.vue?vue&type=template&id=3ca6bd0a"
import script from "./chatRoomItem.vue?vue&type=script&lang=js"
export * from "./chatRoomItem.vue?vue&type=script&lang=js"

import "./chatRoomItem.vue?vue&type=style&index=0&id=3ca6bd0a&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__